import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AuthenticationForm, TextField } from './AuthenticationForm';
import { ButtonLink } from './ButtonLink';
import { FalseGoogleLogin } from './SocialAuthentication/FalseGoogleLogin';
import { withNamespaces } from 'react-i18next';
import { ExternalLink } from './ExternalLink';

const styles = (theme) => ({
  // btnContainer and root apply to forgot password link
  btnContainer: {
    position: 'relative',
  },
  root: {
    position: 'absolute',
    top: '-64px',
    right: '-15px',
    color: '#3d3d3d',
    textTransform: 'capitalize',
    fontSize: '.75em',
    fontFamily: 'Pluto Sans Medium',
    opacity: '0.8',
  },
  submitWrapper: {
    order: 2,
    width: '32%',
    [theme.breakpoints.up('md')]: {
      width: '48%',
    },
  },
  footer__otherAccountPage: {
    order: 3,
  },
  footer__terms: {
    order: 4,
  },
  wrapper: {
    width: '65%',
    marginRight: '5px',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      width: '48%',
    },
  },
});

const SignInTabComponent = ({ classes, handleTabChange, openDialog, t, ...props }) => (
  <div className={classes.tabContainer}>
    <h1 className={classes.title}>{t('sign_in')}</h1>
    <h4 className={classes.subtext}>
      {t(
        'if_you_created_account',
        'If you created an account by entering an email and password, enter them below to sign in.',
      )}
    </h4>
    <AuthenticationForm
      {...props}
      submitLabel={t('sign_in')}
      classes={{
        footer: classes.footer,
        submitWrapper: classes.submitWrapper,
      }}
      footer={
        <>
          <FalseGoogleLogin
            openDialog={openDialog}
            role="button"
            classes={{ wrapper: classes.wrapper }}
          />

          <div className={classes.footer__otherAccountPage}>
            {t('dont_have_account', "Don't have an account")}?{' '}
            <a onClick={(e) => openDialog(e, 'signUp')}>{t('sign_up', 'Sign Up')}</a>
          </div>

          <div className={classes.footer__terms}>
            <ExternalLink to="http://corporate.pluto.tv/privacy-policy">
              {`${t('privacy_policy')}, `}
            </ExternalLink>
            <ExternalLink to="http://corporate.pluto.tv/terms-of-use">
              {`${t('terms_of_service')}, `}
            </ExternalLink>
            <ExternalLink to="https://corporate.pluto.tv/cookie-policy/">
              {`${t('cookie_policy')}, `}
            </ExternalLink>
            {` ${t('and')} `}
            <ExternalLink to="https://viacomprivacy.com">
              {t('do_not_sell_my_personal_info')}
            </ExternalLink>
          </div>
        </>
      }
    >
      <TextField name="email" type="email" label={t('email_address').substring(1)} required />
      <TextField name="password" type="password" label={t('password')} required />
      <div className={classes.btnContainer}>
        <ButtonLink
          classes={{ root: classes.root }}
          onClick={(e) => handleTabChange(e, 'forgotPassword')}
        >
          {t('forgot_password')}
        </ButtonLink>
      </div>
    </AuthenticationForm>
  </div>
);
SignInTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  handleTabChange: PropTypes.func.isRequired,
  onSocialAuth: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
};

export const SignInTab = withStyles(styles)(withNamespaces()(SignInTabComponent));
